import { onCleanup, onMount } from "solid-js";

export function useHeaderOpacityOnScroll() {
  onMount(() => {
    const handleScroll = () => {
      const height = 50;
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const opacity = Math.min(parseFloat((scrollTop / height).toFixed(1)), 1);
      document.documentElement.style.setProperty(
        "--header-opacity",
        `${opacity}`,
      );
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // 页面加载后先执行一次

    onCleanup(() => {
      window.removeEventListener("scroll", handleScroll);
    });
  });
}
